import axios from "axios";
import { newApiBaseUrl } from "../../axiosInstance";

export const GetProductsToOrder = (orderId, branch) => {
  return axios.get(
    `${newApiBaseUrl}/orders/${orderId}/items?branch=${branch}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};
